import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, Card, CardBody, CardSubtitle, CardTitle } from 'reactstrap'

export default function MomentosGeneralTopBar({ reportType }) {
	const [title, setTitle] = useState('')
	const [subtitle, setSubtitle] = useState('')

	useEffect(() => {
		switch (reportType) {
			case 'recompra_total':
				setTitle('Recompra Momentos')
				setSubtitle('Atribución según metricas de nuevo modelo (2026)')
				break;

			case 'gestion_email_marketing':
				setTitle('Gestión Email Marketing')
				setSubtitle('Atribución según metricas de nuevo modelo (2026)')
				break;
			
			case 'gestion_tiendas':
				setTitle('Gestión Tiendas')
				setSubtitle('Atribución según metricas de nuevo modelo (2026)')
				break;

			case 'gestion_cumpleanos':
				setTitle('Gestión Cumpleaños')
				setSubtitle('Atribución según metricas de nuevo modelo (2026)')
				break;
		
			case 'gestion_sms_marketing':
				setTitle('Gestión SMS Marketing')
				setSubtitle('Atribución según metricas de nuevo modelo (2026)')
				break;

			case 'organico':
				setTitle('Otros (Organico)')
				setSubtitle('Atribución según metricas de nuevo modelo (2026)')
				break;

			case 'recompra_fiel_tiendas':
				setTitle('Gestión Tiendas - Reporte por tiendas')
				setSubtitle('Atribución según metricas de nuevo modelo (2026)')
				break;

			default:
				setTitle('Reporte no configurado')
				break;
		}
	}, [ reportType ])

	return (
		<React.Fragment>
			<Card>
				<CardBody>
					<div className='float-right'>
						<Link to="/dashboards/momentos">
							<Button color="primary" outline>Ver otros reportes</Button>
						</Link>
					</div>
					<CardTitle>{title}</CardTitle>
					<CardSubtitle>{subtitle}</CardSubtitle>
				</CardBody>
			</Card>
		</React.Fragment>
	)
}